var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_317_1977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.8098 19.2742C49.5153 8.12345 38.6156 0.94413 27.4649 3.23864C17.9168 5.20346 11.0505 13.5883 11.0067 23.3363C11.0067 23.8007 11.0259 24.2762 11.0671 24.7792C4.27443 25.4982 -0.649292 31.5876 0.0697227 38.3803C0.736173 44.6763 6.04961 49.4525 12.3808 49.4464H13.8238C13.7908 48.9902 13.7551 48.5367 13.7551 48.0721C13.7551 38.2057 21.7534 30.2073 31.6199 30.2073C41.4864 30.2073 49.4846 38.2057 49.4846 48.0721C49.4846 48.5365 49.4489 48.99 49.4159 49.4464H50.8588C59.1982 49.4692 65.9771 42.7272 65.9999 34.3878C66.0218 26.3858 59.7974 19.7563 51.8098 19.2742Z",
    fill: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6197 63.1884C39.9682 63.1884 46.736 56.4206 46.736 48.0721C46.736 39.7236 39.9682 32.9558 31.6197 32.9558C23.2712 32.9558 16.5034 39.7236 16.5034 48.0721C16.5034 56.4206 23.2712 63.1884 31.6197 63.1884Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6199 57.6917C30.8609 57.6917 30.2456 57.0764 30.2456 56.3175V39.8269C30.2456 39.0679 30.8609 38.4526 31.6199 38.4526C32.3788 38.4526 32.9941 39.0679 32.9941 39.8269V56.3175C32.994 57.0764 32.3788 57.6917 31.6199 57.6917Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1165 46.6981C36.9359 46.6984 36.757 46.6632 36.59 46.5943C36.4231 46.5254 36.2713 46.4243 36.1435 46.2968L31.6196 41.7701L27.0956 46.2968C26.5497 46.8241 25.6797 46.8089 25.1524 46.263C24.9049 46.0068 24.7666 45.6645 24.7666 45.3083C24.7666 44.9521 24.9049 44.6098 25.1524 44.3536L30.6493 38.8567C31.1859 38.3202 32.0558 38.3202 32.5925 38.8567L38.0894 44.3536C38.6252 44.8911 38.6239 45.7612 38.0863 46.297C37.8288 46.5538 37.4801 46.698 37.1165 46.6981Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_317_1977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadicon);
export default __webpack_public_path__ + "static/media/uploadicon.5c9c7c92f5060685b167b2678d616e91.svg";
export { ForwardRef as ReactComponent };